import { Section } from "@/components/sections/Section";
import type { Section as SectionType } from "@/types/global";

type CardsSection = Extract<SectionType, { type: "cards" }>;

export function Cards({ settings, data }: CardsSection) {
  const { title, content, items } = data;
  return (
    <Section settings={settings}>
      {title && (
        <>
          <h2 className="heading-jumbo-small">{title}</h2>
          <span className="separateur" />
        </>
      )}
      {content && (
        <div
          className="mt-6 max-w-3xl text-base md:text-lg leading-relaxed text-foreground/90"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      <div className="mt-10 grid gap-6 md:grid-cols-2">
        {items.map((item, i) => (
          <div
            key={i}
            className="group flex items-center gap-4 border border-border bg-card p-6 rounded-sm hover:border-primary transition-smooth"
          >
            <span className="font-display font-black text-2xl text-gradient-fire shrink-0">+</span>
            <h3 className="font-display font-bold uppercase text-base md:text-lg leading-snug">
              {item.title}
            </h3>
          </div>
        ))}
      </div>
    </Section>
  );
}
